export default __webpack_public_path__ + "locales/lv/Webhooks.json?hash=ce0c01edd1df58a311cfad47e89c9218";